/*
 * @Author: kim
 * @Date: 2021-08-30 11:39:47
 * @Description: 自定义route
 */
import { queryStringify } from '../utils'

const DEV_58 = 'https://yiqijian-video.dev58.myzaker.com'
const PROD = 'https://creative.yiqijian.com'

// 路由
const route = {
  dev: {
    index: './index.html',
    list: './media-list.html',
    detail: './media-detail.html',
    about: './about.html',
    error: './error.html'
  },
  dev58: {
    index: DEV_58,
    list: `${DEV_58}/videos`,
    detail: `${DEV_58}/detail`,
    about: `${DEV_58}/about`,
    error: `${DEV_58}/404`
  },
  prod: {
    index: PROD,
    list: `${PROD}/videos`,
    detail: `${PROD}/detail`,
    about: `${PROD}/about`,
    error: `${PROD}/404`
  }
}

// 自定义路由器
class ZkRouter {
  constructor(route) {
    this.route = route
  }

  /**
   * @description: 获取基础的url
   * @param {string} name 路由name
   * @return {string}
   */  
   _getBaseUrl(name) {
    if(!name) return ''

    let domain = ''
    if (process.env.NODE_ENV == 'development') {
      // 本地测试
      domain = this.route.dev[name]
    } else if (
      location.href.indexOf('yiqijian-video.dev58.myzaker.com') != -1
    ) {
      // 58 测试
      domain = this.route.dev58[name]
    } else {
      // 正式
      domain = this.route.prod[name]
    }

    return domain || ''
  }

  /**
   * @description: 获取路由地址
   * @param {string} name 路由名称
   * @param {string} path 路由地址
   * @param {object} params 配合name使用（path的时候无效）
   * @param {object} query 路由参数
   * @return {string}
   */  
  getRoute({ name, path = '', params, query }) {
    let url = ''
    // 跳转的路由
    if(name) {
      const baseUrl = this._getBaseUrl(name)

      let extra = ''
      // 测试服不能拼接，因为没有监听 popState
      if (params && process.env.NODE_ENV !== 'development') {
        for (const key in params) {
          if (Object.hasOwnProperty.call(params, key)) {
              extra = `${extra}/${params[key]}`
          }
        }
      }

      url = `${baseUrl + extra}`
    } else {
      const baseUrl = location.href.split('?')[0]
      url = `${baseUrl + path}`
    }

    // 拼接链接参数
    const queryStr = queryStringify(query, true)
    return queryStr ? `${url}?${queryStr}` : url
  }

  /**
   * @description: 用法与vue route 一致
   * @param {string} name 路由名
   * @param {string} path url 地址(从当前页面路由开始)
   * @param {object} params 配合 name 使用
   * @param {object} query 路由参数
   * @param {string} target 打开方式
   * @return {string}
   */  
  push({ name, path = '', params, query, target = '_blank' }) {
    let _queryObj = Object.assign({}, query)
    let hashObj = null

    if (_queryObj.hash) {
      hashObj = _queryObj.hash
      delete _queryObj.hash
    }

    let url = this.getRoute({ name, path, params, query: _queryObj})
    // 哈希路由
    if(hashObj) {
      let hashStr = queryStringify(hashObj).replace('&', '#')
      url += hashStr
    }

    // 打开方式
    if(target === '_blank') {
      window.open(url)
    } else {
      window.location.href = url
    }
  }
//   getUrl: (name, queryObj, isEncode = true) => {
//     let domain = ''
//     const query = queryStringify(queryObj, isEncode)
//     if (process.env.NODE_ENV == 'development') {
//       domain = pages.dev[name]
//     } else if (
//       location.href.indexOf('yiqijian-video.dev58.myzaker.com') != -1
//     ) {
//       domain = pages.dev58[name]
//     } else {
//       domain = pages.prod[name]
//     }
//     return `${domain}?${query}`
//   }
}

export default new ZkRouter(route)



// WEBPACK FOOTER //
// ./pc/yiqijian-video/config/zkRouter.js